$(document).on('ready', () => {
  if ($('#managers-management-show-manager').length !== 0) {
    // Setup loading on resend
    $('#resend-invite').on('click', function () {
      $('.full-spinner').css('display', 'block')
    })
  }
})
